module.exports = __webpack_public_path__ + "img/Group 30.1cf16d95.png";